//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TRACKER_CLICK, TRACKER_HIDDEN_ACTION } from '@/scripts/constants/tracker'

export default {
  name: 'rb-3d-toggle',
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    dataElementId: {
      type: String,
      default: '',
    },
    dataDescription: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => ({}),
    },
    skeletonIsVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getColor() {
      return this.isSelected ? 'red' : 'light-grey'
    },
  },
  methods: {
    onClick() {
      this.callback(this.id)
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: this.dataElementId,
          data_description: this.dataDescription,
        },
      })
    },
  },
}
